import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import { LOAD_PARTICIPANTS } from "../../../../store/lender-submit-actions";
import { LOAD_BROKERAGE_OVERRIDES } from "../../../../../../../settings/store/settings-actions";
import { GET_CO_BROKERING_OVERRIDES } from "../../../../../../../settings/store/settings-getters";
import Agent from "./agent";
import SubmissionAgent from "./submission-agents.vue";
import ParticipantsLoader from "./participants-loader.vue";
import ParticipantsCoBroker from "./participants-co-broker.vue";
import Err from "../../../../../../../../routes/error";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import SyncAgentFromExpertModal from "./sync-agent-from-expert-modal.vue";
import { CURRENT_ACCOUNT_ACCESS_RIGHTS, REFERRAL_SOURCE_ENABLED } from "@Broker/@Modules/main/store/account/account-getters";
import { CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES } from "@Broker/@Modules/clients/applications/application/store/application-getters";
import ParticipantReferrer from "./participant-referrer.vue";
import CoBrokerModal from "./co-broker-modal.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ParticipantsContainer",
  components: {
    Agent,
    SubmissionAgent,
    ParticipantsLoader,
    SimpleButton,
    SyncAgentFromExpertModal,
    ParticipantReferrer,
    ParticipantsCoBroker,
    CoBrokerModal
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("AccountStore", [REFERRAL_SOURCE_ENABLED, CURRENT_ACCOUNT_ACCESS_RIGHTS])), mapGetters("ApplicationStore", [CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES])), mapGetters("SettingsStore", [GET_CO_BROKERING_OVERRIDES])), {}, {
    r() {
      return this.CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES;
    },
    hasCoBrokeringOverrides() {
      return this.GET_CO_BROKERING_OVERRIDES.overrideCobrokering;
    },
    coBrokeringTooltip() {
      const messageMap = {
        noRequestedMortgagesToCoBroker: this.$t("direct-to-lender.participants.noRequestedMortgagesToCoBroker"),
        noCoBrokeringOverrides: this.$t("direct-to-lender.participants.noCoBrokeringOverrides")
      };
      return !this.hasCoBrokeringOverrides ? messageMap.noCoBrokeringOverrides : messageMap.noRequestedMortgagesToCoBroker;
    },
    allowCoBroker() {
      return this.CURRENT_ACCOUNT_ACCESS_RIGHTS.coBroker;
    }
  }),
  mounted() {
    this.LOAD_BROKERAGE_OVERRIDES();
    this.LOAD_PARTICIPANTS({
      agentUsername: this.agentUsername
    }).then(() => {
      this.loading = false;
    }).catch(Err.handle);
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [LOAD_PARTICIPANTS])), mapActions("SettingsStore", [LOAD_BROKERAGE_OVERRIDES]))
});